<app-modal
  [title]="isVoucherPosition()
    ? ('Gutscheinnummer eingeben' | trans:'online-orders/code-input-modal/voucher/header/title')
    : ('Kartennummer eingeben' | trans:'online-orders/code-input-modal/card/header/title')"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      @if (hasInputPosition()) {
        <p class="m-b-16">
          {{ 'Position [[index]] von [[total]]: [[itemName]] · [[amount]]' | trans:'online-orders/code-input-modal/instruction.Text':instructionReplacements() }}
        </p>
      }
      <app-form-control
        label="{{ 'Code' | trans:'online-orders/code-input-modal/code.Label' }}"
      >
        <input
          #codeInput
          type="text"
          [(ngModel)]="code"
          [disabled]="isLoading()"
          (keydown.enter)="onSubmit()"
          placeholder="{{ isVoucherPosition()
            ? ('z.B. 1234 5678 9012' | trans:'online-orders/code-input-modal/voucher/code.Placeholder')
            : ('z.B. 1234 5678 9012' | trans:'online-orders/code-input-modal/card/code.Placeholder') }}"
        >
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        [disabled]="isLoading()"
        (click)="close()"
      >
        {{ 'Abbrechen' | trans:'online-orders/code-input-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!code || isLoading()"
        (click)="onSubmit()"
      >
        {{ 'Bestätigen' | trans:'online-orders/code-input-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
